// This file is generated.
export var version = '1.48.0';
//# sourceMappingURL=version.js.map